export const setModalHandler = (payload: any, dispatch: any) => {
  dispatch({
    type: "SET_MODAL",
    payload: payload,
  });
};
